import React from 'react'
import AboutUsComponent from '../../components/AboutUsComponent/AboutUsComponent';
import Header from '../../components/allQuestionsComponent/Header';

function AboutUsPage()
{
    return(
        <div>
            <Header/>
            <AboutUsComponent/>
        </div>
    )
}

export default AboutUsPage;